import { Checkbox } from '@tonic-one/react';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useField } from 'formik';
import { CommonFormikProps } from './type';

const CheckboxFormik = forwardRef(
  ({ name, label, ...restProps }: CommonFormikProps, ref) => {
    const [field, meta, helpers] = useField(name);
    const { value, onChange } = field;
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    useImperativeHandle(ref, () => ({
      ...meta,
      ...helpers,
      ...inputRef.current,
    }));
    return (
      <>
        <Checkbox
          ref={inputRef}
          mr="1x"
          value={Number(!!value)}
          checked={!!value}
          onChange={onChange}
          name={name}
          {...restProps}
        >
          {label}
        </Checkbox>
      </>
    );
  }
);

export default CheckboxFormik;
